import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  socket;
  eventEmitter: EventEmitter<any> = new EventEmitter();

  constructor( ) {
    this.socket = io(environment.apiUrl);
  }

  public listen(eventName: string) {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      })
    })
  }
  public emit(eventName: string, data: any) {
    this.socket.emit(eventName, data);
  }
}
